export const getSupplyPrice = (
  supplyParts: {
    unitPriceNet: number
    quantity: number
    originalPriceNet: number
    unitCustomDiscount: number
    discountAmount: {
      gross: number
    }
  }[],
  withDiscount = true
) => {
  return supplyParts.reduce((prevPart, currPart) => {
    if (withDiscount) {
      return (
        prevPart +
        (currPart.originalPriceNet - currPart.discountAmount.gross / currPart.quantity - currPart.unitCustomDiscount) *
          currPart.quantity
      )
    }
    return prevPart + currPart.originalPriceNet * currPart.quantity
  }, 0)
}

export const createLinkAndDownloadFile = (url: string, fileName: string) => {
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName) //or any other extension
  if (typeof link.download === 'undefined') {
    link.setAttribute('target', '_blank')
  }
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export const downloadFile = async (
  link: string,
  beforeStart: () => void,
  onDone: () => Promise<void>,
  onError: (e) => void,
  showMessage: (msg: string, variant: 'warning' | 'success' | 'error') => void
): Promise<FileReader | void> => {
  try {
    beforeStart()
    const response = await fetch(link + '?json=true', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    const responseData = await response.json()
    if (responseData.url) {
      console.log('download file', responseData.url)
      createLinkAndDownloadFile(responseData.url, responseData.fileName || 'filename')
      onDone()
    } else if (responseData.message) {
      showMessage(responseData.message, responseData.variant || 'success')
    }
  } catch (e) {
    console.error(e)
    onError(e)
  }
}
